import { humanizeStr } from '@/helpers/form/formatting'

const defaultValues = {
    props: {
        form: {
            type: Object,
            default: () => ({
                data: {},
                rules: {},
                errors: [],
            }),
        },
        fieldKey: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        caseInsensitiveMatch: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: String,
            default: 'auto',
        },

        nestedProperty: {
            type: String,
            default: null,
        },
    },
    computed: {
        getLabel() {
            return this.label ? this.label : humanizeStr(this.fieldKey)
        },
        value: {
            get() {
                if (this.nestedProperty) {
                    return this.caseInsensitiveMatch
                        ? this.form.data[this.fieldKey][this.nestedProperty]?.toLowerCase()
                        : this.form.data[this.fieldKey][this.nestedProperty]
                }

                return this.caseInsensitiveMatch
                    ? this.form.data[this.fieldKey]?.toLowerCase()
                    : this.form.data[this.fieldKey]
            },
            set(val) {
                if (this.$attrs.type === 'number') {
                    val = parseInt(val)
                }
                if (this.nestedProperty) {
                    this.form.data[this.fieldKey][this.nestedProperty] = val
                } else {
                    this.form.data[this.fieldKey] = val
                }
            },
        },
        rules() {
            if (this.nestedProperty) {
                return this.form.rules[this.fieldKey][this.nestedProperty]
            }

            return this.form.rules[this.fieldKey]
        },
    },
    methods: {
        clearErrors() {
            delete this.form.errors[this.fieldKey]
        },
    },
}

export default defaultValues
